/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuotaHistoryItemFromJSON, QuotaHistoryItemToJSON } from './QuotaHistoryItem';
/**
 * Check if a given object implements the QuotaHistoryResponse interface.
 */
export function instanceOfQuotaHistoryResponse(value) {
    if (!('items' in value) || value['items'] === undefined)
        return false;
    return true;
}
export function QuotaHistoryResponseFromJSON(json) {
    return QuotaHistoryResponseFromJSONTyped(json, false);
}
export function QuotaHistoryResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        ...json,
        'items': (json['items'].map(QuotaHistoryItemFromJSON)),
    };
}
export function QuotaHistoryResponseToJSON(json) {
    return QuotaHistoryResponseToJSONTyped(json, false);
}
export function QuotaHistoryResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        ...value,
        'items': (value['items'].map(QuotaHistoryItemToJSON)),
    };
}
